import Cookie from "js-cookie";
import { DashboardIndicators } from "./DashboardIndicators";
import { useTranslation } from "react-i18next";

const Dashboard = ({ user, corporation }) => {
  const { t } = useTranslation();
  const firstName = user?.firstName || Cookie.get("firstName") || "";

  return (
    <div className="settings-page-wrapper">
      <div className="settings-content-wrapper dashboard-content-wrapper">
        <DashboardIndicators
          corporation={corporation}
          welcomeTitle={`${t("Welcome")}${firstName ? ` ${firstName}` : ""},`}
        />
      </div>
    </div>
  );
};

export default Dashboard;
